<template>
    <div>
        <div class="login-content" style="display: block">
            <div class="form-group row align-items-end">
                <div class="col-md-4">
                    <label class="col-form-label text-md-left">From</label>
                    <input
                        v-model="filters.from_datetime"
                        type="datetime-local"
                        class="form-control"
                    />
                </div>

                <div class="col-md-4">
                    <label class="col-form-label text-md-left">To</label>
                    <input
                        v-model="filters.to_datetime"
                        type="datetime-local"
                        class="form-control"
                    />
                </div>

                <div class="col-md-4">
                    <label class="col-form-label text-md-left">Search</label>
                    <input
                        v-model="tableData.search"
                        type="text"
                        class="form-control"
                        placeholder="Invoice, error, user"
                        @keyup.enter="fetchAll()"
                    />
                </div>
            </div>

            <div class="form-group row align-items-center mt-3">
                <div class="col-md-2">
                    <button type="button" class="btn-small-width btn-purple" @click="fetchAll()">
                        Get Data
                    </button>
                </div>

                <div class="col-md-2">
                    <button type="button" class="btn-small-width btn-purple" @click="clearFilters()">
                        Clear Value
                    </button>
                </div>

                <div class="col-md-4">
                    <button type="button" class="btn-small-width btn-yello" @click="openPdf()">
                        <i class="fas fa-print"></i> Download PDF
                    </button>
                </div>

                <div class="col-md-2 offset-md-2 text-end">
                    <label class="mb-0">Rows</label>
                    <select v-model="tableData.length" class="form-select" @change="fetchList()">
                        <option v-for="records in perPage" :key="records" :value="records">
                            {{ records }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div v-show="loading" class="text-center">
            <div class="spinner-border spinner-border-lg text-success" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <div v-show="!loading">
            <div class="row summary-row">
                <div class="col-md-4">
                    <div class="summary-card">
                        <label>Cancel Invoices</label>
                        <p>{{ summary.totalCancelInvoices }}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="summary-card">
                        <label>Cancel Tickets</label>
                        <p>{{ summary.totalCancelTickets }}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="summary-card">
                        <label>Cancel Amount</label>
                        <p>LKR {{ summary.totalCancelAmount }}</p>
                    </div>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Invoice ID</th>
                            <th>Ticket Count</th>
                            <th>Amount</th>
                            <th>Reversed By ID</th>
                            <th>Reversed By Name</th>
                            <th>Center</th>
                            <th>Error Type</th>
                            <th>Error Reason</th>
                            <th>Reversed At</th>
                            <th>View</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="record in records" :key="record.id">
                            <td>{{ record.invoice_id }}</td>
                            <td>{{ record.tickets }}</td>
                            <td>{{ toCurrency(record.amount) }}</td>
                            <td>{{ record.reverse_by }}</td>
                            <td>{{ record.reverse_by_name }}</td>
                            <td>{{ displayCenter(record) }}</td>
                            <td>{{ record.issue_type }}</td>
                            <td>{{ record.log }}</td>
                            <td>{{ formatDate(record.created_at) }}</td>
                            <td>
                                <a :href="'/reports/view-invoice/' + record.invoice_id" target="_blank">
                                    <i class="fas fa-eye"></i>
                                </a>
                            </td>
                        </tr>
                        <tr v-if="records.length === 0">
                            <td colspan="10" class="text-center">No cancellation records found.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <pagination
                :pagination="pagination"
                @prev="fetchList(pagination.prevPageUrl)"
                @next="fetchList(pagination.nextPageUrl)"
            >
            </pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            filters: {
                from_datetime: "",
                to_datetime: "",
            },
            summary: {
                totalCancelInvoices: 0,
                totalCancelTickets: 0,
                totalCancelAmount: "0.00",
            },
            records: [],
            perPage: [10, 20, 30],
            loading: false,
            tableData: {
                draw: 0,
                length: 10,
                search: "",
                column: 8,
                dir: "desc",
            },
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
        };
    },

    created() {
        this.setTodayRange();
        this.fetchAll();
    },

    methods: {
        setTodayRange() {
            const now = new Date();
            const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0);
            const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59);
            this.filters.from_datetime = this.toDateTimeLocal(start);
            this.filters.to_datetime = this.toDateTimeLocal(end);
        },

        toDateTimeLocal(date) {
            const pad = (value) => String(value).padStart(2, "0");
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
        },

        requestParams() {
            return {
                from_datetime: this.filters.from_datetime,
                to_datetime: this.filters.to_datetime,
                search: this.tableData.search,
                length: this.tableData.length,
                column: this.tableData.column,
                dir: this.tableData.dir,
                draw: this.tableData.draw,
            };
        },

        fetchAll() {
            this.fetchSummary();
            this.fetchList();
        },

        fetchSummary() {
            this.loading = true;
            axios
                .get("/reports/get-my-cancellation-summary", { params: this.requestParams() })
                .then((response) => {
                    this.summary = response.data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                    Toast.fire({
                        icon: "error",
                        title: "Something went wrong!",
                    });
                });
        },

        fetchList(url = null) {
            this.loading = true;
            this.tableData.draw++;
            const requestUrl = url || "/reports/get-my-cancellation-list";
            const requestConfig = url ? {} : { params: this.requestParams() };

            axios
                .get(requestUrl, requestConfig)
                .then((response) => {
                    const data = response.data;
                    if (this.tableData.draw == data.draw) {
                        this.records = data.data.data;
                        this.configPagination(data.data);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                    Toast.fire({
                        icon: "error",
                        title: "Something went wrong!",
                    });
                });
        },

        openPdf() {
            const params = new URLSearchParams({
                from_datetime: this.filters.from_datetime,
                to_datetime: this.filters.to_datetime,
                search: this.tableData.search,
            });
            window.open(`/reports/my-cancellation-data?${params.toString()}`, "_blank");
        },

        clearFilters() {
            this.tableData.search = "";
            this.setTodayRange();
            this.fetchAll();
        },

        configPagination(data) {
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        toCurrency(value) {
            const numericValue = parseFloat(value);
            return !isNaN(numericValue)
                ? numericValue.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                  })
                : "0.00";
        },

        formatDate(value) {
            if (!value) {
                return "";
            }
            const date = new Date(value);

            if (Number.isNaN(date.getTime())) {
                return value;
            }

            const pad = (number) => String(number).padStart(2, "0");

            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        },

        displayCenter(record) {
            return record.center_name
                ? `${record.center_name} (${record.center})`
                : record.center;
        },
    },
};
</script>

<style scoped>
.summary-row {
    margin: 10px 0 20px;
}

.summary-card {
    border: 1px solid #d8d8d8;
    border-radius: 8px;
    padding: 14px;
    background: #fafafa;
}

.summary-card label {
    display: block;
    color: #555;
    font-weight: 600;
}

.summary-card p {
    margin: 6px 0 0;
    color: #111;
    font-size: 22px;
    font-weight: 700;
}

a:hover {
    cursor: pointer;
}
</style>
